/**
 * CSSC Referrer Module
 *
 * Contains referrer domain to campaign code mappings and utility functions
 */
/**
 * Map of referrer domains to their corresponding CSSC campaign codes.
 * Used to automatically attribute traffic from known social media sites and search engines.
 */
export var referrerCampaignMap = new Map([
    ["facebook.com", "1089290"],
    ["myspace.com", "1089291"],
    ["linkedin.com", "1089299"],
    ["caringbridge.org", "10892910"],
    ["gaiaonline.com", "10892912"],
    ["beliefnet.com", "10892914"],
    ["wordpress.com", "10892920"],
    ["typepad.com", "10892922"],
    ["blogger.com", "10892923"],
    ["youtube.com", "10892926"],
    ["stumbleupon.com", "10892928"],
    ["flickr.com", "10892929"],
    ["answers.yahoo.com", "10892930"],
    ["groups.yahoo.com", "10892931"],
    ["yelp.com", "10892933"],
    ["twitter.com", "10892935"],
    ["x.com", "10892935"],
    ["delicious.com", "10892936"],
    ["bing.com", "13150413"],
    ["google.com", "1315040"],
    ["search.yahoo.com", "1315041"],
    ["search.msn.com", "1315042"],
    ["lycos.com", "1315043"],
    ["search.aol.com", "1315044"],
    ["search.earthlink.net", "1315045"],
    ["search.netscape.com", "1315046"],
    ["ask.com", "1315047"],
    ["altavista.com", "1315048"],
    ["dogpile.com", "1315049"],
    ["excite.com", "13150410"]
]);
/**
 * Extracts and returns a CSSC based on the document's referrer hostname.
 *
 * @returns The campaign string if the referrer hostname matches a known domain,
 *          or null if there's no referrer or no matching campaign for the referrer
 */
export var getReferrerCampaign = function () {
    var referrer = document.referrer;
    if (!referrer)
        return null;
    // Fast hostname extraction without DOM manipulation
    var hostname = '';
    var start = referrer.indexOf('://');
    if (start !== -1) {
        var end = referrer.indexOf('/', start + 3);
        hostname = end !== -1
            ? referrer.substring(start + 3, end)
            : referrer.substring(start + 3);
        if (hostname.indexOf('www.') === 0) {
            hostname = hostname.substring(4);
        }
    }
    return referrerCampaignMap.get(hostname) || null;
};
